import { render, staticRenderFns } from "./author.vue?vue&type=template&id=a6c0cce0&scoped=true&lang=pug&"
import script from "./author.vue?vue&type=script&lang=js&"
export * from "./author.vue?vue&type=script&lang=js&"
import style0 from "./author.vue?vue&type=style&index=0&id=a6c0cce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c0cce0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/image.vue').default})
